import { FormProps } from 'antd/lib/form';

export const scrollOptions: FormProps['scrollToFirstError'] = {
  block: 'center',
};
